import { Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../../environments/environment';
import { StandingItem } from '../../../../models/standing.model';
import { ScoresSportsService } from '../../../../services/scores-sports.service';
import { UtilitiesService } from '../../../../services/utilities.service';
import { SportsService } from '../../../../services/sport.service';
import { CommonModule } from '@angular/common';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { RouterLink } from '@angular/router';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'app-standings-football',
  standalone: true,
  imports: [
    CommonModule,
    NzGridModule,
    RouterLink,
    NzSkeletonComponent,
    NzTableModule,
    NzToolTipModule,
    TranslateModule,
  ],
  templateUrl: './standings-football.component.html',
  styleUrl: './standings-football.component.scss',
})
export class StandingsFootballComponent {
  @Input() idCompetition: string | null = null;

  sportSelected: string | null = null;

  standingArray: any = {};
  filterSelected: any = 'All';
  loader = true;

  urlSVG = environment.urlIcon;
  urlIMG = environment.urlIMG;

  listOfColumn = [
    {
      title: '#',
      compare: (a: StandingItem, b: StandingItem) => a.position - b.position,
      priority: 1,
      show: true,
      tooltip: this.translateService.instant('Position'),
      fixed: true,
      width: '15px',
      align: 0,
    },
    {
      title: this.translateService.instant('Team'),
      compare: (a: StandingItem, b: StandingItem) =>
        a.nameTeam.localeCompare(b.nameTeam),
      priority: 2,
      show: true,
      tooltip: this.translateService.instant('Team'),
      fixed: true,
      width: '80px',
      align: 0,
    },
    {
      title: this.translateService.instant('GP'),
      compare: (a: StandingItem, b: StandingItem) => a.total - b.total,
      priority: 2,
      show: true,
      tooltip: this.translateService.instant('Matches'),
      fixed: false,
      width: '20px',
      align: 2,
    },
    {
      title: this.translateService.instant('W'),
      compare: (a: StandingItem, b: StandingItem) => a.won - b.won,
      priority: 2,
      show: true,
      tooltip: this.translateService.instant('Win'),
      fixed: false,
      width: '20px',
      align: 2,
    },
    {
      title: this.translateService.instant('T'),
      compare: (a: StandingItem, b: StandingItem) => a.draw - b.draw,
      priority: 2,
      show: true,
      tooltip: this.translateService.instant('Tied'),
      fixed: false,
      width: '20px',
      align: 2,
    },
    {
      title: this.translateService.instant('L'),
      compare: (a: StandingItem, b: StandingItem) => a.loss - b.loss,
      priority: 2,
      show: true,
      tooltip: this.translateService.instant('Loss'),
      fixed: false,
      width: '20px',
      align: 2,
    },
    {
      title: this.translateService.instant('GD'),
      compare: (a: StandingItem, b: StandingItem) => a.goal_diff - b.goal_diff,
      priority: 2,
      show: true,
      tooltip: this.translateService.instant('Diff'),
      fixed: false,
      width: '20px',
      align: 2,
    },
    {
      title: this.translateService.instant('PTS'),
      compare: (a: StandingItem, b: StandingItem) => a.points - b.points,
      priority: 2,
      show: true,
      tooltip: this.translateService.instant('Points'),
      fixed: false,
      width: '30px',
      align: 2,
    },
  ];

  constructor(
    private scoresServices: ScoresSportsService,
    public utilityService: UtilitiesService,
    private readonly translateService: TranslateService,
    private readonly sportsServices: SportsService,
  ) {}

  ngOnInit(): void {
    this.sportSelected = this.sportsServices.getSelectedSport();
  }

  ngOnChanges(): void {
    this.loader = true;
    this.loadStandingCompetition(this.idCompetition);
  }

  loadStandingCompetition(idCompetition: any): void {
    this.standingArray = {};

    if (idCompetition)
      this.scoresServices.getStandingsCompetition(idCompetition).subscribe(
        (result: any) => {
          if (result) {
            this.standingArray = result.data;
            this.loader = false;
          } else this.loader = false;
        },
        () => {
          this.loader = false;
        }
      );
  }
}
